<div class="elementor-element elementor-element-51dc4360 elementor-button-align-stretch elementor-widget elementor-widget-form" data-id="51dc4360" data-element_type="widget" data-settings="{&quot;step_next_label&quot;:&quot;Next&quot;,&quot;step_previous_label&quot;:&quot;Previous&quot;,&quot;button_width&quot;:&quot;100&quot;,&quot;step_type&quot;:&quot;number_text&quot;,&quot;step_icon_shape&quot;:&quot;circle&quot;}" data-widget_type="form.default">
    <h4>
        MyPlus Rewards sign up
    </h4>
    <div class="elementor-widget-container">
        <form class="elementor-form customer-sign-up-form" @submit.prevent="validateForm">
            <div class="elementor-form-fields-wrapper elementor-labels-">
                <div class="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-FullName elementor-col-100 elementor-field-required">
                    <label for="form-field-attendantName" class="elementor-field-label elementor-screen-only">
                        Attendant Number
                    </label>
                    <input type="text" id="form-field-attendantName" class="elementor-field elementor-size-sm  elementor-field-textual" placeholder="Attendant Number" required="required" aria-required="true" v-model="attendantNumber.value">
                </div>
                <dropdown
                    :selectOptions="sites"
                    :selectedOption="selectedSiteId"
                    :elementId="'siteDropdown'"
                    :placeholder="'Select Site'"
                    @changeSelect="onSiteDropdownChange"></dropdown>
                <div class="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-FullName elementor-col-100 elementor-field-required">
                    <label for="form-field-cardBarcode" class="elementor-field-label elementor-screen-only">
                        Card Barcode
                    </label>
                    <div v-if="cardBarcode.hasError" class="text-danger">
                        {{cardBarcode.errorMessage}}
                    </div>
                    <input type="text" id="form-field-cardBarcode" class="elementor-field elementor-size-sm  elementor-field-textual" placeholder="Card Barcode" required="required" aria-required="true" v-model="cardBarcode.value">
                </div>
                <div class="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-email elementor-col-100 elementor-field-required">
                    <label for="form-field-dateOfBirth" class="elementor-field-label elementor-screen-only">
                        Date Of Birth
                    </label>
                    <div v-if="dateOfBirth.hasError" class="text-danger">
                        {{dateOfBirth.errorMessage}}
                    </div>
                    <VueDatePicker
                        v-model="dateOfBirth.value"
                        :enable-time-picker="false"
                        :format="dateFormat"
                        placeholder="Date of Birth"></VueDatePicker>
<!--                    <input type="date" id="form-field-dateOfBirth" class="elementor-field elementor-size-sm  elementor-field-textual" placeholder="Date Of Birth (DD/MM/YYYY eg. 25/05/1996)" >-->
                </div>
                <div class="elementor-field-type-select-multiple elementor-field-group elementor-column elementor-field-group-FullName elementor-col-100 elementor-field-required">
                    <label for="form-field-gender" class="elementor-field-label elementor-screen-only">
                        Gender
                    </label>
                    <select id="form-field-gender" class="elementor-field elementor-size-sm  elementor-field-type-select-multiple" v-model="genderId">
                        <option value="-1" disabled selected>Select Gender</option>
                        <option value="0">Rather Not Say</option>
                        <option value="1">Male</option>
                        <option value="2">Female</option>
                    </select>
                </div>
                <div class="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-FullName elementor-col-100 elementor-field-required">
                    <label for="form-field-email" class="elementor-field-label elementor-screen-only">
                        Email Address
                    </label>
                    <div v-if="emailAddress.hasError" class="text-danger">
                        {{emailAddress.errorMessage}}
                    </div>
                    <input type="email" id="form-field-email" class="elementor-field elementor-size-sm  elementor-field-textual" placeholder="Email Address" required="required" aria-required="true" v-model="emailAddress.value">
                    <p>
                        All communication regarding points earned and redeemed will be done via email.
                    </p>
                </div>
                <div class="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-FullName elementor-col-100 elementor-field-required">
                    <input type="checkbox" id="form-field-emailCommunication" class="elementor-field elementor-size-sm  elementor-field-type-checkbox" v-model="acceptPromotionalOffers">
                    <label for="form-field-emailCommunication" class="elementor-field-label">
                        Receive promotional emails and other newsletters
                    </label>
                </div>
<!--                <h5>-->
<!--                    Place of Residence-->
<!--                </h5>-->
<!--                <div class="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-FullName elementor-col-100 elementor-field-required">-->
<!--                    <label for="form-field-street" class="elementor-field-label elementor-screen-only">-->
<!--                        Street-->
<!--                    </label>-->
<!--                    <input type="text" id="form-field-street" class="elementor-field elementor-size-sm  elementor-field-textual" placeholder="Street" v-model="residentialAddress.street">-->
<!--                </div>-->
<!--                <div class="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-FullName elementor-col-100 elementor-field-required">-->
<!--                    <label for="form-field-suburb" class="elementor-field-label elementor-screen-only">-->
<!--                        Suburb-->
<!--                    </label>-->
<!--                    <input type="text" id="form-field-suburb" class="elementor-field elementor-size-sm  elementor-field-textual" placeholder="Suburb" v-model="residentialAddress.suburb">-->
<!--                </div>-->
<!--                <div class="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-FullName elementor-col-100 elementor-field-required">-->
<!--                    <label for="form-field-city" class="elementor-field-label elementor-screen-only">-->
<!--                        City-->
<!--                    </label>-->
<!--                    <input type="text" id="form-field-city" class="elementor-field elementor-size-sm  elementor-field-textual" placeholder="City" v-model="residentialAddress.city">-->
<!--                </div>-->
                <div class="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-FullName elementor-col-100 elementor-field-required">
                    <label for="form-field-province" class="elementor-field-label elementor-screen-only">
                        Province
                    </label>
                    <input type="text" id="form-field-province" class="elementor-field elementor-size-sm  elementor-field-textual" placeholder="Province" v-model="residentialAddress.province">
                </div>
<!--                <div class="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-FullName elementor-col-100 elementor-field-required">-->
<!--                    <label for="form-field-postalCode" class="elementor-field-label elementor-screen-only">-->
<!--                        Postal Code-->
<!--                    </label>-->
<!--                    <input type="text" id="form-field-postalCode" class="elementor-field elementor-size-sm  elementor-field-textual" placeholder="Postal Code" v-model="residentialAddress.postalCode">-->
<!--                </div>-->
                <div class="elementor-field-group elementor-column elementor-field-type-submit elementor-col-100 e-form__buttons">
                    <button type="submit" class="elementor-button elementor-size-sm" :disabled="loading">
                        <span>
                            <span class=" elementor-button-icon">
                            </span>
                            <span class="elementor-button-text">Sign Up</span>
                        </span>
                    </button>
                </div>
            </div>
        </form>
    </div>
</div>
